import { nanoid } from "@reduxjs/toolkit";
import { callApiActionInterface } from "./Actions/actionInterface";

export const deviceRegisterApi: callApiActionInterface = {
  actionType: "callApi",
  method: "POST",
  endpoint: "/device/register",
  onResponse: [
    {
      actionType: "cookieOperation",
      operation: "SET",
      key: "deviceId",
      getDynamicValueStructur: {
        source: "DEFAULT",
        key: "device",
        field: {
          key: "identifier",
        },
      },
    },
  ],
  dynamicPayload: [
    {
      key: "device_identifier",
      staticValue: nanoid(),
    },
    {
      key: "device_type",
      staticValue: "Web",
    },
  ],
};
